/*!
 * @license
 * Copyright © 2005-2024 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { BaseApi } from './base.api';
import { buildCollectionParam } from '../../../alfrescoApiClient';
import { throwIfNotDefined } from '../../../assert';
export class ClassificationReasonsApi extends BaseApi {
    createClassificationReason(classificationReason) {
        throwIfNotDefined(classificationReason, 'classificationReason');
        return this.post({
            path: '/classification-reasons',
            bodyParam: classificationReason
        });
    }
    deleteClassificationReason(classificationReasonId) {
        throwIfNotDefined(classificationReasonId, 'classificationReasonId');
        const pathParams = {
            classificationReasonId
        };
        return this.delete({
            path: '/classification-reasons/{classificationReasonId}',
            pathParams
        });
    }
    listClassificationReasons(opts) {
        const queryParams = {
            skipCount: opts === null || opts === void 0 ? void 0 : opts.skipCount,
            maxItems: opts === null || opts === void 0 ? void 0 : opts.maxItems,
            fields: buildCollectionParam(opts === null || opts === void 0 ? void 0 : opts.fields, 'csv')
        };
        return this.get({
            path: '/classification-reasons',
            queryParams
        });
    }
    showClassificationReasonById(classificationReasonId) {
        throwIfNotDefined(classificationReasonId, 'classificationReasonId');
        const pathParams = {
            classificationReasonId
        };
        return this.get({
            path: '/classification-reasons/{classificationReasonId}',
            pathParams
        });
    }
    updateClassificationReason(classificationReasonId, classificationReason) {
        throwIfNotDefined(classificationReasonId, 'classificationReasonId');
        throwIfNotDefined(classificationReason, 'classificationReason');
        const pathParams = {
            classificationReasonId
        };
        return this.put({
            path: '/classification-reasons/{classificationReasonId}',
            pathParams,
            bodyParam: classificationReason
        });
    }
}
